class HamNavToggle {
  constructor(el, opt){
    this.el = el;
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    const hamNav = '.js-ham-nav';
    const hamNavOpen = '.js-ham-open';
    const hamNavClose = '.js-ham-close';
    $(hamNavOpen).on('click',function(){
      $(hamNav).fadeIn().css('display','flex');
    })
    $(hamNavClose).on('click',function(){
      $(hamNav).fadeOut();
    })
  }

}
